import { Controller } from "stimulus"
import OS from "../lib/os"

// The /get download section (_includes/download-section.html). Every
// platform's panel, button and card is already in the page; this only shows
// the visitor's platform with the download for their architecture, and hides
// the rest, so no copy lives in here.
export default class DownloadSectionController extends Controller {
  static get targets() {
    return ['platform', 'primary', 'alt', 'card']
  }

  async initialize() {
    const os = new OS()
    const detectedOs = this.detectOs(os)
    const { arch } = await os.detectArch()

    this.show(detectedOs, arch)
    this.element.classList.add('download-grid--ready')
  }

  detectOs(os) {
    if (os.macos()) return 'macos'
    if (os.linux()) return 'linux'
    return 'windows'
  }

  // Pick the first downloadable option whose arch matches; if no arch match,
  // first downloadable option; external-only platforms fall back to first.
  pickPrimary(options, arch) {
    return options.find(o => o.dataset.arch === arch && !o.dataset.external) ||
           options.find(o => !o.dataset.external) ||
           options[0]
  }

  show(platformId, arch) {
    const panel = this.platformTargets.find(p => p.dataset.platform === platformId) ||
                  this.platformTargets[0]
    this.platformTargets.forEach(p => { p.hidden = p !== panel })
    this.cardTargets.forEach(c => { c.hidden = c.dataset.platform === panel.dataset.platform })

    const options = this.primaryTargets.filter(o => panel.contains(o))
    const primary = this.pickPrimary(options, arch)
    options.forEach(o => { o.hidden = o !== primary })

    // The other formats, with their arch shown only where it differs.
    this.altTargets.filter(a => panel.contains(a)).forEach((alt) => {
      alt.hidden = alt.dataset.option === primary.dataset.option
      const tag = alt.querySelector('.arch')
      if (tag) tag.hidden = alt.dataset.arch === primary.dataset.arch
    })
  }

  // Click handler on the "See all N formats" link inside an OS card —
  // shows that platform in the primary band instead.
  switchTo(event) {
    event.preventDefault()
    this.show(event.currentTarget.dataset.platform, 'x86_64')
    const top = this.element.querySelector('.dl-primary')
    if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
